import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslations from "./locales/english/en.json";
import nanTranslations from "./locales/hokkien/nan.json";
import zhTranslations from "./locales/mandarin/zh.json";

const getCookieDomain = () => {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return hostname;
  }
  return ".speakhokkien.org";
};

const cookieDomain = getCookieDomain();
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      nan: { translation: nanTranslations },
      zh: { translation: zhTranslations },
    },
    fallbackLng: "zh",
    detection: {
      order: ["cookie", "localStorage"],
      caches: ["cookie", "localStorage"],
      lookupCookie: "i18nextLng",
      lookupLocalStorage: "i18nextLng",
      cookieOptions: {
        path: "/",
        domain: cookieDomain,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

// Helper function to set cookie
const setCookie = (name: string, value: string, days = 365) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const securePart = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${value}; expires=${expires}; path=/; domain=${cookieDomain}${securePart}`;
};

// overwrites default i18nextLng value from LanguageDetector, prevents init to english issue
const storedLang =
  localStorage.getItem("i18nextLng") ||
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("i18nextLng="))
    ?.split("=")[1];

const supportedLanguages = ["en", "nan", "zh"];

if (!storedLang || !supportedLanguages.includes(storedLang)) {
  i18n.changeLanguage("zh");
  setCookie("i18nextLng", "zh");
} else {
  i18n.changeLanguage(storedLang);
}

// Listen for language changes and update cookie
i18n.on("languageChanged", (lng) => {
  setCookie("i18nextLng", lng);
});

export default i18n;
